<template>
  <div class="container">
    <BaseFrame
      :breadcrumb="[
        {
          name: 'pointApply',
          title: '积分申请'
        },
        {
          name: 'pointApplyCreate',
          title: '查看'
        }
      ]"
    >
      <div slot="content">
         <lk-card title="申请内容" class="other-card">
          <div class="head-container">
            <div class="row">
              <div class="item">
                <div class="title">申请门店：</div>
                <span>{{ storePoint.storeName }}</span>
              </div>
              <div class="item">
                <div class="title">申请年份：</div>
                {{ storePoint.yearVal }}
              </div>
            </div>
            <div class="row row-gap">
              <div class="item">
                <div class="title">本次申请积分：</div>
                 {{ storePoint.exchangeNum }}
              </div>
              <div class="item">
                <div class="title">可申请积分：</div>
                {{ storePoint.integalNum }}
              </div>
            </div>
          </div>
          <div class="apply-container">
            <div class="row">
              <div class="title">申请明细：</div>
              <div>
                <lk-table
                  class="content"
                  border
                  :columns="columns"
                  :data="tableData"
                />
                <lk-page
                    class="page-style"
                    :total="count"
                    :current.sync="page"
                    :page-size="size"
                    show-sizer
                    show-elevator
                    show-total
                    @on-page-size-change='handlePageSize'
                    @on-change='handlePage'
                    :page-size-opts='[10, 20,30,50,100]'
                  />
              </div>
            </div>
            <div class="row row-gap">
              <div class="title">申请备注：</div>
              <div style="max-width:800px;">{{ storePoint.remark }}</div>
            </div>
            <div class="row row-gap">
              <div class="title">审批状态：</div>
              <div>{{ storePoint.auditStatusStr }}</div>
            </div>
            <div class="row row-gap" v-if="storePoint.receiptPics">
              <div class="title">签收单：</div>
              <div>
                <a
                  v-for="(item, index) in storePoint.receiptPics"
                  :key="index"
                  :href="item"
                  download
                  style="text-decoration:none;
                  display: block;">
                  下载签收单({{index+1}})
                </a>
              </div>

            </div>
          </div>
        </lk-card>
      </div>
    </BaseFrame>
  </div>
</template>

<script>

import _ from 'lodash';
import BaseFrame from '@/components/frame/NewBaseFrame.vue';
import utils from '../../../libs/utils';
import pointService from '../../../services/points';

export default {
  name: 'pointsApplyCreate',
  components: {
    BaseFrame,
  },
  data() {
    return {
      loading: false,
      size: 10,
      count: 0,
      page: 1,
      storePoint: {
      },
      columns: [
        { title: '患者信息', key: 'patientInfo', minWidth: 160 },
        { title: '本次申请', key: 'num', minWidth: 116 },
      ],
      tableData: [],
    };
  },
  methods: {
    handlePageSize(val) {
      this.size = val;
      this.selectionData = { };
      this.getData();
    },
    handlePage(val) {
      this.page = val;
      this.getData();
    },
    getData() {
      const params = {
        exchangeId: this.$route.params.id,
        page: this.page,
        size: this.size,
      };
      pointService.pointApplyDetailList(params).then((res) => {
        if (res.data.status === 200) {
          const tmp = [];
          this.count = res.data.data.count;
          res.data.data.list.forEach((item) => {
            const pat = /(\d{3})\d*(\d{4})/;
            item.patientInfo = `${item.patientName[0]}* ${item.patientPhone.replace(pat, '$1****$2')}`;
            tmp.push(item);
          });
          this.tableData = tmp;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getStorePoints() {
      const params = {
        id: this.$route.params.id,
      };
      pointService.pointApplyDetailInfo(params)
        .then((res) => {
          if (res.data.status !== 200) {
            this.$Message.error(res.data.error);
            return;
          }
          if (res.data.data.receiptPics) {
            res.data.data.receiptPics = res.data.data.receiptPics.map((e) => {
              const url = !e.includes('https') ? e.replace('http', 'https') : e;
              return decodeURIComponent(url);
            });
          }
          this.storePoint = res.data.data;
        })
        .catch((err) => {
          utils.handleError(err);
        });
    },
  },
  created() {
    this.getData();
    this.getStorePoints();
  },
};
</script>
<style lang="less" scoped>

.other-card{
  margin-top: 30px;
}

.page-style {
  display: flex;
  justify-content: flex-end;
  margin-top: 12px;
}

.head-container {
  margin: 20px;
  .row {
    display: flex;
    justify-content: space-between;
    .item {
      .title {
        width: 100px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin-right: 20px;
      }
      width: 300px;
      display: flex;
      align-items: center;
    }
  }

}
.row-gap {
  margin-top: 16px;
}

.apply-container {
  padding: 20px;
  .row {
    display: flex;
    flex: none;
    align-items: flex-start;
    .title {
      width: 100px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      margin-right: 20px;
      flex: none;
    }
    .content {
      width: 800px
    }
  }
}
</style>
